import { Box, DialogContent, MenuItem, Grid } from '@mui/material';
import {
  CustomTextField,
  CustomSelect,
  CustomTextArea,
  CustomAutoComplete,
} from '../../../../../common/components';

/**
 * Tab de datos generales del proyecto
 * Siguiendo el patrón del ContractIndividualEditDialog
 */
const GeneralDataTab = ({
  localProject,
  handleInputChange,
  handleSelectChange,
  editMode,
  subcontractors = [],
  subcontractorsLoading = false,
}) => {
  const statusOptions = [
    { value: 'not_started', label: 'Sin empezar' },
    { value: 'in_progress', label: 'En progreso' },
    { value: 'completed', label: 'Completado' },
    { value: 'cancelled', label: 'Cancelado' },
  ];
  const subcontractorOptions = subcontractors
    .filter(
      (subcontractor) =>
        subcontractor?.is_subcontractor === true || subcontractor?.is_subcontractor === '1'
    )
    .map((subcontractor) => {
      const label =
        subcontractor.company ||
        subcontractor.legal_business_name ||
        subcontractor.cuit ||
        'Subcontratista sin nombre';
      return {
        ...subcontractor,
        value: subcontractor.uuid,
        label,
      };
    });

  return (
    <Box>
      <DialogContent>
        <Grid container spacing={3}>
          {/* Columna Izquierda: Nombre y Descripción */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {editMode && (
                <CustomTextField
                  label="Nombre del Proyecto"
                  name="name"
                  value={localProject?.name || ''}
                  onChange={handleInputChange}
                  size="medium"
                  required
                  fullWidth
                />
              )}

              <CustomTextArea
                label="Descripción"
                name="description"
                value={localProject?.description || ''}
                onChange={handleInputChange}
                size="medium"
                multiline
                rows={ !editMode ? 7.3 : 4.2}
                fullWidth
              />

              <CustomAutoComplete
                label="Subcontratista"
                name="uuid_subcontractor"
                value={localProject?.uuid_subcontractor || ''}
                onChange={handleSelectChange}
                size="medium"
                options={subcontractorOptions}
                optionValueKey="value"
                optionLabelKey="label"
                placeholder="Sin subcontratista"
                disabled={subcontractorsLoading}
              />
            </Box>
          </Grid>

          {/* Columna Derecha: Estado y Fechas */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomSelect
                label="Estado"
                name="status"
                value={localProject?.status || 'not_started'}
                onChange={handleSelectChange}
                size="medium"
                fullWidth
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </CustomSelect>

              <CustomTextField
                label="Mes de inicio de obra"
                name="start_date"
                type="month"
                value={localProject?.start_date || ''}
                onChange={handleInputChange}
                size="medium"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />

              <CustomTextField
                label="Mes de fin de obra"
                name="end_date"
                type="month"
                value={localProject?.end_date || ''}
                onChange={handleInputChange}
                size="medium"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Box>
  );
};

export default GeneralDataTab;
